import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { SymbolGroupsAction } from '../../symbolGroups.action';

export const SymbolGroupsSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SymbolGroupsAction.load.started());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(SymbolGroupsAction.destroy());
    };
  }, [dispatch]);

  return null;
};
